import { FC } from 'react';
import * as stylex from '@stylexjs/stylex';
import { Button } from '@shared/ui/kit';
import { formatEventDate } from '@shared/libs/format-event-date';
import { styles } from '../../styles';
import WaitingClockImg from '@pages/qr-page/assets/waiting-clock.webp';
import { palette } from '@shared/tokens/palette.stylex';

type PendingInviteProps = {
  eventName: string;
  dateStart: string;
  dateEnd: string;
  onAccept?: () => void;
  onDecline?: () => void;
};

export const InviteDecision: FC<PendingInviteProps> = ({ eventName, dateStart, dateEnd, onAccept, onDecline }) => {
  const formattedDate = formatEventDate(dateStart, dateEnd);

  return (
    <div {...stylex.props(styles.content)}>
      <img src={WaitingClockImg} alt="Мероприятие ещё не началось" {...stylex.props(styles.statusIllustration)} />
      <div {...stylex.props(styles.titleContent)}>
        <h3 {...stylex.props(styles.titleStatus)}>Ты приглашен на мероприятие</h3>
        <p {...stylex.props(styles.date)}>{formattedDate}</p>
        <h2 {...stylex.props(styles.titleInfo)}>«{eventName}»</h2>
      </div>

      <div {...stylex.props(styles.actionsRow)}>
        <Button
          variant="secondary"
          size="medium"
          onClick={onDecline}
          settings={{
            fontSize: '18px',
            padding: '12px 24px',
            whiteSpace: 'nowrap',
            color: palette.greyBlack,
            border: `1px solid ${palette.greyBlack}`,
          }}
        >
          Не приду
        </Button>

        <Button
          variant="accent"
          size="medium"
          onClick={onAccept}
          settings={{ fontSize: '18px', padding: '12px 24px', whiteSpace: 'nowrap' }}
        >
          Я пойду на мероприятие
        </Button>
      </div>
    </div>
  );
};
